import { UpdateSpaceRequest, UpdateSpaceResponse } from "@functions-types";
import { makeCloudFunction } from "../makeCloudFunction";

export const updateSpace = makeCloudFunction<
  UpdateSpaceRequest,
  UpdateSpaceResponse
>("space", "updateSpace");
